module.exports = __webpack_public_path__ + "img/thumbnail_Axolotl_u_melanistic.555b627f.png";